// extracted by mini-css-extract-plugin
export default {"infocard":"Chatcard_infocard__oCMKN","img":"Chatcard_img__vnno1","text":"Chatcard_text__ENA8H"};